/**
 * @fileoverview gRPC-Web generated client stub for sgn.explorer.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.29.3
// source: explorer/explorer.proto

/* eslint-disable */
// @ts-nocheck

import * as grpcWeb from "grpc-web";

import * as explorer_explorer_pb from "./explorer_pb"; // proto import: "explorer/explorer.proto"

export class ExplorerClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string };
  options_: null | { [index: string]: any };

  constructor(
    hostname: string,
    credentials?: null | { [index: string]: string },
    options?: null | { [index: string]: any }
  ) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options["format"] = "binary";

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, "");
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorGetTotalStats = new grpcWeb.MethodDescriptor(
    "/sgn.explorer.v1.Explorer/GetTotalStats",
    grpcWeb.MethodType.UNARY,
    explorer_explorer_pb.GetTotalStatsRequest,
    explorer_explorer_pb.GetTotalStatsResponse,
    (request: explorer_explorer_pb.GetTotalStatsRequest) => {
      return request.serializeBinary();
    },
    explorer_explorer_pb.GetTotalStatsResponse.deserializeBinary
  );

  getTotalStats(
    request: explorer_explorer_pb.GetTotalStatsRequest,
    metadata?: grpcWeb.Metadata | null
  ): Promise<explorer_explorer_pb.GetTotalStatsResponse>;

  getTotalStats(
    request: explorer_explorer_pb.GetTotalStatsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetTotalStatsResponse
    ) => void
  ): grpcWeb.ClientReadableStream<explorer_explorer_pb.GetTotalStatsResponse>;

  getTotalStats(
    request: explorer_explorer_pb.GetTotalStatsRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetTotalStatsResponse
    ) => void
  ) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ + "/sgn.explorer.v1.Explorer/GetTotalStats",
        request,
        metadata || {},
        this.methodDescriptorGetTotalStats,
        callback
      );
    }
    return this.client_.unaryCall(
      this.hostname_ + "/sgn.explorer.v1.Explorer/GetTotalStats",
      request,
      metadata || {},
      this.methodDescriptorGetTotalStats
    );
  }

  methodDescriptorGetDailyTotalLiquidity = new grpcWeb.MethodDescriptor(
    "/sgn.explorer.v1.Explorer/GetDailyTotalLiquidity",
    grpcWeb.MethodType.UNARY,
    explorer_explorer_pb.GetDailyTotalLiquidityRequest,
    explorer_explorer_pb.GetDailyTotalLiquidityResponse,
    (request: explorer_explorer_pb.GetDailyTotalLiquidityRequest) => {
      return request.serializeBinary();
    },
    explorer_explorer_pb.GetDailyTotalLiquidityResponse.deserializeBinary
  );

  getDailyTotalLiquidity(
    request: explorer_explorer_pb.GetDailyTotalLiquidityRequest,
    metadata?: grpcWeb.Metadata | null
  ): Promise<explorer_explorer_pb.GetDailyTotalLiquidityResponse>;

  getDailyTotalLiquidity(
    request: explorer_explorer_pb.GetDailyTotalLiquidityRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTotalLiquidityResponse
    ) => void
  ): grpcWeb.ClientReadableStream<explorer_explorer_pb.GetDailyTotalLiquidityResponse>;

  getDailyTotalLiquidity(
    request: explorer_explorer_pb.GetDailyTotalLiquidityRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTotalLiquidityResponse
    ) => void
  ) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTotalLiquidity",
        request,
        metadata || {},
        this.methodDescriptorGetDailyTotalLiquidity,
        callback
      );
    }
    return this.client_.unaryCall(
      this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTotalLiquidity",
      request,
      metadata || {},
      this.methodDescriptorGetDailyTotalLiquidity
    );
  }

  methodDescriptorGetDailyTransactionCount = new grpcWeb.MethodDescriptor(
    "/sgn.explorer.v1.Explorer/GetDailyTransactionCount",
    grpcWeb.MethodType.UNARY,
    explorer_explorer_pb.GetDailyTransactionCountRequest,
    explorer_explorer_pb.GetDailyTransactionCountResponse,
    (request: explorer_explorer_pb.GetDailyTransactionCountRequest) => {
      return request.serializeBinary();
    },
    explorer_explorer_pb.GetDailyTransactionCountResponse.deserializeBinary
  );

  getDailyTransactionCount(
    request: explorer_explorer_pb.GetDailyTransactionCountRequest,
    metadata?: grpcWeb.Metadata | null
  ): Promise<explorer_explorer_pb.GetDailyTransactionCountResponse>;

  getDailyTransactionCount(
    request: explorer_explorer_pb.GetDailyTransactionCountRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTransactionCountResponse
    ) => void
  ): grpcWeb.ClientReadableStream<explorer_explorer_pb.GetDailyTransactionCountResponse>;

  getDailyTransactionCount(
    request: explorer_explorer_pb.GetDailyTransactionCountRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTransactionCountResponse
    ) => void
  ) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTransactionCount",
        request,
        metadata || {},
        this.methodDescriptorGetDailyTransactionCount,
        callback
      );
    }
    return this.client_.unaryCall(
      this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTransactionCount",
      request,
      metadata || {},
      this.methodDescriptorGetDailyTransactionCount
    );
  }

  methodDescriptorGetDailyTransactionVolume = new grpcWeb.MethodDescriptor(
    "/sgn.explorer.v1.Explorer/GetDailyTransactionVolume",
    grpcWeb.MethodType.UNARY,
    explorer_explorer_pb.GetDailyTransactionVolumeRequest,
    explorer_explorer_pb.GetDailyTransactionVolumeResponse,
    (request: explorer_explorer_pb.GetDailyTransactionVolumeRequest) => {
      return request.serializeBinary();
    },
    explorer_explorer_pb.GetDailyTransactionVolumeResponse.deserializeBinary
  );

  getDailyTransactionVolume(
    request: explorer_explorer_pb.GetDailyTransactionVolumeRequest,
    metadata?: grpcWeb.Metadata | null
  ): Promise<explorer_explorer_pb.GetDailyTransactionVolumeResponse>;

  getDailyTransactionVolume(
    request: explorer_explorer_pb.GetDailyTransactionVolumeRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTransactionVolumeResponse
    ) => void
  ): grpcWeb.ClientReadableStream<explorer_explorer_pb.GetDailyTransactionVolumeResponse>;

  getDailyTransactionVolume(
    request: explorer_explorer_pb.GetDailyTransactionVolumeRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyTransactionVolumeResponse
    ) => void
  ) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTransactionVolume",
        request,
        metadata || {},
        this.methodDescriptorGetDailyTransactionVolume,
        callback
      );
    }
    return this.client_.unaryCall(
      this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyTransactionVolume",
      request,
      metadata || {},
      this.methodDescriptorGetDailyTransactionVolume
    );
  }

  methodDescriptorGetDailyUniqueUser = new grpcWeb.MethodDescriptor(
    "/sgn.explorer.v1.Explorer/GetDailyUniqueUser",
    grpcWeb.MethodType.UNARY,
    explorer_explorer_pb.GetDailyUniqueUserRequest,
    explorer_explorer_pb.GetDailyUniqueUserResponse,
    (request: explorer_explorer_pb.GetDailyUniqueUserRequest) => {
      return request.serializeBinary();
    },
    explorer_explorer_pb.GetDailyUniqueUserResponse.deserializeBinary
  );

  getDailyUniqueUser(
    request: explorer_explorer_pb.GetDailyUniqueUserRequest,
    metadata?: grpcWeb.Metadata | null
  ): Promise<explorer_explorer_pb.GetDailyUniqueUserResponse>;

  getDailyUniqueUser(
    request: explorer_explorer_pb.GetDailyUniqueUserRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyUniqueUserResponse
    ) => void
  ): grpcWeb.ClientReadableStream<explorer_explorer_pb.GetDailyUniqueUserResponse>;

  getDailyUniqueUser(
    request: explorer_explorer_pb.GetDailyUniqueUserRequest,
    metadata?: grpcWeb.Metadata | null,
    callback?: (
      err: grpcWeb.RpcError,
      response: explorer_explorer_pb.GetDailyUniqueUserResponse
    ) => void
  ) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyUniqueUser",
        request,
        metadata || {},
        this.methodDescriptorGetDailyUniqueUser,
        callback
      );
    }
    return this.client_.unaryCall(
      this.hostname_ + "/sgn.explorer.v1.Explorer/GetDailyUniqueUser",
      request,
      metadata || {},
      this.methodDescriptorGetDailyUniqueUser
    );
  }
}
